import React, {useEffect, useState} from 'react';
import BootstrapTable from "react-bootstrap-table-next";

import {Button, Container} from "react-bootstrap";
import {Link} from "react-router-dom";
import ToolkitProvider, {Search} from 'react-bootstrap-table2-toolkit';
import "../style/SearchBar.css"
import LoadingLoginScreen from "./LoadingLoginScreen";


export default function UserGrid({users, companyValues, loading}) {

    const {SearchBar} = Search;


    const [readOnly, setReadOnly] = useState(true);

    const editUser = (cell) => {
        return (
            <Link to={`accountdetails/${cell}`}>
                <Button onClick={() => setReadOnly(!readOnly)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                         className="bi bi-pencil" viewBox="0 0 16 16">
                        <path
                            d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z"/>
                    </svg>
                </Button>
            </Link>
        )
    }

    const showAuth = (cell) => {
        switch (cell) {
            case true:
                return "Webb";

            case null:
                return "App";

            case false:
                return "App";

            default:
                return 'Inga rättigheter';
        }
    }


    const columns = [

        {

            dataField: 'firstName',
            text: 'Förnamn',
            sort: true,
        }, {
            dataField: 'lastName',
            text: 'Efternamn',
            sort: true,
        }, {
            dataField: 'email',
            text: 'E-post',
            sort: true,
        },
        {
            dataField: "id",
            text: "Redigera användare",
            formatter: editUser,
            sort: false
        },
        {
            dataField: 'allowWeb',
            text: 'Kontotyp',
            formatter: showAuth,
            sort: true,
        }
    ];


    return (
        <React.Fragment>
            {loading ? <LoadingLoginScreen/> :
                <Container fluid className={"leadsGrid"}>

                    <Container>
                        Antal lediga konton för <b>{companyValues.companyName}</b> : {companyValues.amountofAccounts}
                        <hr/>
                    </Container>
                    <ToolkitProvider
                        keyField="id"
                        data={users}
                        columns={columns}
                        search
                    >
                        {props => (
                            <div>
                                <SearchBar placeholder="Sök" srText={null}
                                           className="SearchBar" {...props.searchProps} />
                                <BootstrapTable wrapperClasses="table-responsive" {...props.baseProps} />
                            </div>
                        )}
                    </ToolkitProvider>

                </Container>
            }
        </React.Fragment>
    )
}
